import { createAction } from '@ngrx/store';

export const toggleThemeMode = createAction('[Theme] Toggle Theme');
